/* eslint-disable */
<template>
  <div>
    <div v-for="(service, key) of services">{{ key }} ==> {{ service }}</div>
    <div v-for="(service, key) of days">{{ key }} ==> {{ service }}</div>
    <div v-for="(service, key) of jobs">{{ key }} ==> {{ service }}</div>
    <div v-for="(service, key) of participants">{{ key }} ==> {{ service }}</div>
  </div>
</template>

<script>
  import fire from '../firebase'

export default {

    data () {
      return {
        services: {},
        days: {},
        jobs: {},
        participants: {}
      }
    },

  // #2 tried the following but failed
    created () {
      this.refToObject('services')
      this.refToObject('days')
      this.refToObject('jobs')
      this.refToObject('participants')
    },

    methods: {

      init: function () {
        let list = {}
        fire.db.ref('services').on('child_added', function (service) {
          list[service.key] = service.val()
        })
        this.services = Object.assign({}, this.services, list)

        console.log('ss', this.services)
      },

      refToObject: function (name) {
        let list = {}
        fire.db.ref(name).on('child_added', function (item) {
          list[item.key] = item.val()
        })
        this[name] = Object.assign({}, this[name], list)
      }

    },

/// merge ext

    getNodes: function (path) {

    }

  }
  </script>



// WEBPACK FOOTER //
// src/components/test.vue